export default "__VITE_ASSET__BYWCk1DA__ 584w";